import { httpClient } from '../../../services/http/httpClient.js';

const TEAMS_API_URL = '/api/teams';
const TASKS_API_URL = '/api/tasks';

const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }

    searchParams.append(key, String(value));
  });

  return searchParams.toString();
};

const buildUrl = (baseUrl, params = {}) => {
  const queryString = buildQueryString(params);
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

const createServiceError = (message, error) => {
  const serviceError = new Error(message);
  serviceError.cause = error;
  serviceError.status = error?.status;
  serviceError.payload = error?.payload ?? error?.data ?? null;
  return serviceError;
};

const normalizeStatistics = (payload) => ({
  totalTasks: Number(payload?.totalTasks) || 0,
  tasksByStatus: Array.isArray(payload?.tasksByStatus) ? payload.tasksByStatus : []
});

const normalizeTeamPerformance = (payload) => ({
  totalTasks: Number(payload?.totalTasks) || 0,
  completedTasks: Number(payload?.completedTasks) || 0
});

const normalizeTaskTypeCounts = (payload) => (Array.isArray(payload) ? payload : []);

const normalizeDensityMap = (payload) => ({
  heatMapPoints: Array.isArray(payload?.heatMapPoints) ? payload.heatMapPoints : [],
  countNoLocation: Number(payload?.countNoLocation) || 0,
  totalTasks: Number(payload?.totalTasks) || 0
});

const normalizeRanking = (payload) => (Array.isArray(payload) ? payload : []);

const getDateFilters = (filters = {}) => {
  if (filters.dateRange === 'period') {
    return {
      dateFrom: filters.dateFrom,
      dateTo: filters.dateTo
    };
  }

  return { dateType: filters.dateRange };
};

const getCommonFilters = (filters = {}) => ({
  typeTask: filters.typeTask,
  ...getDateFilters(filters)
});

const getTeamDateFilters = (filters = {}) => ({
  team: filters.teamId,
  ...getCommonFilters(filters)
});

export const adminHomeService = {
  getTaskStatistics: async (filters = {}) => {
    try {
      const payload = await httpClient.get(buildUrl(`${TASKS_API_URL}/statistics`, getTeamDateFilters(filters)));
      return normalizeStatistics(payload);
    } catch (error) {
      throw createServiceError('Error al cargar estadisticas', error);
    }
  },

  getTeamPerformance: async (filters = {}) => {
    try {
      const payload = await httpClient.get(buildUrl(`${TEAMS_API_URL}/teamPerformance`, getTeamDateFilters(filters)));
      return normalizeTeamPerformance(payload);
    } catch (error) {
      throw createServiceError('Error al cargar rendimiento de equipos', error);
    }
  },

  getTaskTypeCounts: async (filters = {}) => {
    try {
      const payload = await httpClient.get(buildUrl(`${TASKS_API_URL}/taskTypeCounts`, getTeamDateFilters(filters)));
      return normalizeTaskTypeCounts(payload);
    } catch (error) {
      throw createServiceError('Error al cargar tipos de tareas', error);
    }
  },

  getDensityMap: async (filters = {}) => {
    try {
      const payload = await httpClient.get(buildUrl(`${TASKS_API_URL}/densityMap`, getTeamDateFilters(filters)));
      return normalizeDensityMap(payload);
    } catch (error) {
      throw createServiceError('Error al cargar mapa de densidad', error);
    }
  },

  getTeamRanking: async (filters = {}) => {
    try {
      const payload = await httpClient.get(buildUrl(`${TEAMS_API_URL}/ranking`, getCommonFilters(filters)));
      return normalizeRanking(payload);
    } catch (error) {
      throw createServiceError('Error al cargar ranking de equipos', error);
    }
  }
};
